import { render, staticRenderFns } from "./PurchasePaymentApproved.vue?vue&type=template&id=2f98807b"
import script from "./PurchasePaymentApproved.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports